module.exports = __webpack_public_path__ + "img/banner-auth.b45bcbbd.svg";